import { type ModalOnClose, type ModalSize } from './types.js';
import { createContext, type HTMLAttributes } from 'react';

export type ModalContextValue = {
  isDismissible: boolean;
  onClose: ModalOnClose;
  size: ModalSize;
  titleProps: HTMLAttributes<HTMLElement>;
};

export const ModalContext = createContext<ModalContextValue | null>(null);
